export const storage = {
  language: 'language',
};
